import { AbstractControl } from '@angular/forms';

/**
 * The upload id `ee-uploader` was given for the file a control holds.
 *
 * Kept beside the control rather than in its value: the attorney intake posts the File itself as
 * multipart, while a JSON submit (PM case create) sends `{upload_id, name, type}`, which the server
 * turns into an attachment. Weakly held, so a destroyed form takes its ids with it.
 */
const staged = new WeakMap<AbstractControl, string>();

export function stageUpload(control: AbstractControl | null | undefined, uploadId: string): void {
  if (control) staged.set(control, uploadId);
}

export function clearStagedUpload(control: AbstractControl | null | undefined): void {
  if (control) staged.delete(control);
}

/** Null until the file has finished uploading and passed its scan. */
export function stagedUploadId(control: AbstractControl | null | undefined): string | null {
  return (control && staged.get(control)) ?? null;
}

/**
 * A file answer whose upload has not finished; the submit must not go without it.
 *
 * Shared by every JSON submit that sends staged uploads (PM case create, the v2 intake wizard), so a
 * caller can tell "wait" from a real failure with one `instanceof`. `then` finishes the sentence for the
 * surface that throws it.
 */
export class FileStillUploadingError extends Error {
  constructor(readonly label: string, then = 'create the case') {
    super(`${label} is still uploading. Wait for it to finish, then ${then}.`);
    this.name = 'FileStillUploadingError';
  }
}

/** A file answer whose upload failed (infected, rejected, or the upload itself failed). */
export class FileUploadFailedError extends Error {
  constructor(readonly label: string) {
    super(`${label} could not be uploaded. Remove it and choose the file again.`);
    this.name = 'FileUploadFailedError';
  }
}
